"use client";
import { jsxs as l, jsx as e, Fragment as C } from "react/jsx-runtime";
import { useState as T, useId as E, useRef as L, useEffect as D } from "react";
import { cn as r } from "../utils/cn.js";
import { N3wthProvider as Z } from "../theme/N3wthProvider.js";
import { n3wthTheme as A } from "../theme/n3wthTheme.js";
import { useRouteScrollReset as te } from "../hooks/useRouteScrollReset.js";
import { ReadingOutline as ie } from "./ReadingOutline.js";
import { Heading as F } from "../packages/ui/node_modules/@astryxdesign/core/dist/Heading/Heading.js";
import { Text as O } from "../packages/ui/node_modules/@astryxdesign/core/dist/Text/Text.js";
function $({ as: t = "div", className: n, ...i }) {
  return /* @__PURE__ */ e(t, { className: r("n3wth-site-container", n), ...i });
}
function B({ className: t, ...n }) {
  return /* @__PURE__ */ e("section", { className: r("n3wth-site-section", t), ...n });
}
function G({ className: t, ...n }) {
  return /* @__PURE__ */ e("nav", { className: r("n3wth-site-section-links", t), ...n });
}
const H = { page: 1, section: 2, item: 3 };
function M({ variant: t = "section", level: n, className: i, children: s, ...a }) {
  return /* @__PURE__ */ e(F, { level: n ?? H[t], className: r("n3wth-site-heading", `n3wth-site-heading--${t}`, i), ...a, children: s });
}
function R({ variant: t = "body", as: n = "p", className: i, children: s, ...a }) {
  return /* @__PURE__ */ e(O, { as: n, type: t === "lede" ? "body" : t, display: n === "span" ? "inline" : "block", className: r("n3wth-site-text", `n3wth-site-text--${t}`, i), ...a, children: s });
}
function W({ title: t, level: n = 2, className: i, children: s, ...a }) {
  return /* @__PURE__ */ l("div", { className: r("n3wth-site-doc-section", i), ...a, children: [
    t != null ? /* @__PURE__ */ e(M, { variant: "section", level: n, children: t }) : null,
    s
  ] });
}
function Y({ items: t, className: n, ...i }) {
  return /* @__PURE__ */ e("ul", { className: r("n3wth-site-doc-list", n), ...i, children: t.map((s, a) => /* @__PURE__ */ e("li", { children: s }, a)) });
}
function z({ title: t, level: n = 1, description: i, actions: s, aside: a, align: h = "start", spacing: m = "default", className: o, ...c }) {
  return /* @__PURE__ */ l("header", { className: r("n3wth-site-page-header", a != null && "n3wth-site-page-header--split", h === "center" && "n3wth-site-page-header--center", m === "compact" && "n3wth-site-page-header--compact", o), ...c, children: [
    /* @__PURE__ */ l("div", { className: "n3wth-site-page-header-copy", children: [
      /* @__PURE__ */ e(M, { variant: n === 1 ? "page" : "section", level: n, children: t }),
      i != null && /* @__PURE__ */ e(R, { className: "n3wth-site-description", children: i }),
      s != null && /* @__PURE__ */ e("div", { className: "n3wth-site-actions", children: s })
    ] }),
    a != null && /* @__PURE__ */ e("div", { className: "n3wth-site-page-header-aside", children: a })
  ] });
}
function J({ brand: t, links: n, actions: i, navigationLabel: s = "Primary", navigationId: a, menuLabel: h = "Open menu", menuContent: m, collapseAt: o = "md", className: c, ...w }) {
  const [d, u] = T(!1), v = E(), f = a ?? `site-navigation-${v}`, g = L(null), N = L(null), b = m != null;
  return D(() => {
    if (!d) return;
    N.current?.querySelector(b ? ".n3wth-site-navigation-menu a" : ".n3wth-site-navigation-links a")?.focus();
    const p = window.matchMedia(`(min-width: ${o === "lg" ? 1024 : 768}px)`), k = () => {
      p.matches && u(!1);
    }, S = (y) => {
      N.current?.contains(y.target) || u(!1);
    }, x = (y) => {
      y.key === "Escape" && (u(!1), g.current?.focus());
    };
    return document.addEventListener("pointerdown", S), document.addEventListener("keydown", x), p.addEventListener("change", k), () => {
      document.removeEventListener("pointerdown", S), document.removeEventListener("keydown", x), p.removeEventListener("change", k);
    };
  }, [d, o, b]), /* @__PURE__ */ e("header", { ...w, ref: N, className: r("n3wth-site-navigation", `n3wth-site-navigation--${o}`, c), children: /* @__PURE__ */ l("div", { className: "n3wth-site-navigation-island", "data-nosnippet": !0, children: [
    /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-brand", onClick: () => u(!1), children: t }),
    /* @__PURE__ */ e("nav", { id: f, "aria-label": s, className: "n3wth-site-navigation-links", "data-open": d, onClick: (p) => {
      p.target.closest("a") && u(!1);
    }, children: b ? /* @__PURE__ */ l(C, { children: [
      /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-inline", children: n }),
      /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-menu", children: m })
    ] }) : n }),
    /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-actions", onClick: () => u(!1), children: i }),
    /* @__PURE__ */ e("button", { ref: g, type: "button", className: "n3wth-site-navigation-toggle", "aria-label": d ? "Close menu" : h, "aria-controls": f, "aria-expanded": d, onClick: () => u((p) => !p), children: /* @__PURE__ */ e("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", "aria-hidden": "true", children: d ? /* @__PURE__ */ e("path", { d: "m6 6 12 12M6 18 18 6" }) : /* @__PURE__ */ e("path", { d: "M4 6h16M4 12h16M4 18h16" }) }) })
  ] }) });
}
function K({ onSubmit: t, label: n = "Occasional notes on agent infrastructure. No spam.", buttonLabel: i = "Subscribe", successMessage: s = "Thanks. You are on the list.", errorMessage: a = "That did not go through. Try again.", className: h, ...m }) {
  const o = E(), [c, w] = T("idle"), d = c === "sending" || c === "done";
  async function u(v) {
    v.preventDefault();
    const f = v.currentTarget, g = new FormData(f).get("email");
    if (!(typeof g != "string" || !f.reportValidity())) {
      w("sending");
      try {
        await t(g.trim()), f.reset(), w("done");
      } catch {
        w("error");
      }
    }
  }
  return /* @__PURE__ */ l("form", { ...m, className: r("n3wth-site-signup", "ph-no-capture", "ph-mask", h), "data-ph-no-capture": !0, onSubmit: u, noValidate: !1, children: [
    /* @__PURE__ */ e("label", { htmlFor: o, className: "n3wth-site-signup-label", children: n }),
    /* @__PURE__ */ l("div", { className: "n3wth-site-signup-row", children: [
      /* @__PURE__ */ e("input", { id: o, name: "email", type: "email", required: !0, autoComplete: "email", inputMode: "email", placeholder: "you@example.com", disabled: d, className: "ph-no-capture ph-mask", "data-ph-no-capture": !0 }),
      /* @__PURE__ */ e("button", { type: "submit", disabled: d, children: i })
    ] }),
    /* @__PURE__ */ e("p", { "aria-live": "polite", className: "n3wth-site-signup-status", children: c === "done" ? s : c === "error" ? a : null })
  ] });
}
function Q({ brand: t = /* @__PURE__ */ e("a", { href: "https://n3wth.com", children: "Oliver Newth" }), links: n, sourceHref: i = "https://github.com/n3wth/n3wth", legalLinks: s, signup: a, children: h, className: m, ...o }) {
  const c = n ?? /* @__PURE__ */ l(C, { children: [
    /* @__PURE__ */ e("a", { href: "https://n3wth.com/library", children: "Library" }),
    /* @__PURE__ */ e("a", { href: "https://skills.n3wth.com", children: "Skills" }),
    /* @__PURE__ */ e("a", { href: "https://r3.n3wth.com", children: "r3" }),
    /* @__PURE__ */ e("a", { href: "https://docs.n3wth.com", children: "Docs" }),
    /* @__PURE__ */ e("a", { href: "https://n3wth.com/contact", children: "Contact" }),
    /* @__PURE__ */ e("a", { href: i, children: "GitHub" }),
    s
  ] });
  return /* @__PURE__ */ e("footer", { ...o, className: r("n3wth-site-footer", m), children: /* @__PURE__ */ l($, { "data-nosnippet": !0, children: [
    a != null && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-signup", children: a }),
    /* @__PURE__ */ l("div", { className: "n3wth-site-footer-row", children: [
      t != null && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-brand", children: t }),
      /* @__PURE__ */ e("nav", { "aria-label": "Footer", className: "n3wth-site-footer-links", children: c })
    ] }),
    h != null && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-meta", children: h })
  ] }) });
}
export {
  Z as N3wthProvider,
  z as PageHeader,
  ie as ReadingOutline,
  $ as SiteContainer,
  Y as SiteDocList,
  W as SiteDocSection,
  Q as SiteFooter,
  M as SiteHeading,
  J as SiteNavigation,
  B as SiteSection,
  G as SiteSectionLinks,
  K as SiteSignup,
  R as SiteText,
  A as n3wthTheme,
  te as useRouteScrollReset
};
//# sourceMappingURL=index.js.map
